import {
  fsXXS,
  fsXXXS,
  fwBold,
} from '@aboutyou/legacy-shared/src/ui/constants/typography'
import React, { FC } from 'react'
import { useConfigStore } from 'store/context'
import { USP } from 'store/features/config'
import styled from 'styled-components'
import { primaryColor } from 'uiComponents/constants/colors'
import { mediaTabletAndDown } from 'uiComponents/constants/customMedia'

const List = styled.ul`
  display: flex;
  justify-content: space-evenly;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* add your IE10-IE11 css here - https://stackoverflow.com/questions/18907131/detecting-ie11-using-css-capability-feature-detection/35063378#35063378 */
    justify-content: center;
  }
`

const UspItem = styled.li`
  max-width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 39px 20px 40px 20px;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* add your IE10-IE11 css here - https://stackoverflow.com/questions/18907131/detecting-ie11-using-css-capability-feature-detection/35063378#35063378 */
    width: 24%;
  }
`

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border: 1px solid ${primaryColor};
  border-radius: 50%;
  margin-bottom: 20px;
  > img {
    height: 16px;
    width: 16px;
  }
`

const IconTitle = styled.div`
  font-size: ${fsXXS}px;
  ${fwBold};
  text-align: center;
  margin-bottom: 12px;

  @media ${mediaTabletAndDown} {
    font-size: ${fsXXXS}px;
  }
`

const IconDescription = styled.div`
  width: 100%;
  text-align: center;
  font-size: ${fsXXS}px;

  @media ${mediaTabletAndDown} {
    font-size: ${fsXXXS}px;
  }
`

const PremiumUSPs: FC = () => {
  const usps = useConfigStore(store => store.premiumUSPs)
  if (!usps) {
    return null
  }
  return (
    <List>
      {Object.keys(usps).map(key => {
        const usp = usps[key as keyof typeof usps]
        return <PremiumUSPItem key={usp.text} usp={usp} />
      })}
    </List>
  )
}

export default PremiumUSPs

const PremiumUSPItem: FC<{ usp: USP }> = ({ usp }) => {
  return (
    <UspItem>
      {usp.image && (
        <Icon>
          <img src={usp.image} alt={usp.text || undefined} />
        </Icon>
      )}
      <IconTitle>{usp.text}</IconTitle>
      <IconDescription>{usp.description}</IconDescription>
    </UspItem>
  )
}
